enum ProductImageTypes {
  Logo = 1,
  PromotionBanner = 2,
  CloverLogo = 3,
}

export default ProductImageTypes;
